class EventsService {
  show(id) {
    window.open(`${process.env.VUE_APP_API_URL}/api/events/${id}.ics`, '_blank');
    // return instance.get(`api/events/${id}.ics`)
  }
}

export default new EventsService();
